/* eslint-disable react/prop-types */
import React, { useMemo, useState } from "react";
import { Box } from "@mui/material";
import Dropdown from "../Dropdown/Dropdown";
import { buildArray } from "../../../../utils/helper";

const getOptions = (data) => data.map((d) => ({ key: d, value: d }));

export function SelectMonthAndYear({ name, readOnly, value, setFieldValue }) {
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);

  const [defaultYear, defaultMonth] = useMemo(() => {
    // backward compatibility for Integer
    if (value && Number.isInteger(value)) {
      return [value, null];
    }
    // backward compatibility for String
    if (value && typeof value === "string") {
      return [Number(value), null];
    }
    if (value) {
      // floating Number
      return String(value).split(".").map(Number);
    }
    return [undefined, undefined];
  }, [value]);

  return (
    <Box style={{ display: "flex", gap: "1rem", marginTop: "10px" }}>
      <Dropdown
        name={`${name}-year`}
        label="Year"
        value={readOnly ? defaultYear : year}
        options={getOptions(buildArray(50))}
        onChange={(e) => {
          setFieldValue(
            name,
            [e.target.value, month].filter(Boolean).join(".")
          );
          setYear(e.target.value);
        }}
        disabled={readOnly}
        style={
          readOnly
            ? {
                backgroundColor: "rgba(239, 239, 239, 1.5)",
                borderRadius: 8,
              }
            : {}
        }
        sx={{ background: "#FFF" }}
      />
      <Dropdown
        name={`${name}-month`}
        label="Month"
        value={readOnly ? defaultMonth : month}
        options={getOptions(buildArray(12))}
        onChange={(e) => {
          if (!year) setFieldValue(name, `0.${e.target.value}`);
          else {
            setFieldValue(
              name,
              [year, e.target.value].filter(Boolean).join(".")
            );
          }
          setMonth(e.target.value);
        }}
        disabled={readOnly}
        style={
          readOnly
            ? {
                backgroundColor: "rgba(239, 239, 239, 1.5)",
                borderRadius: 8,
              }
            : {}
        }
        sx={{ background: "#FFF" }}
      />
      <input type="hidden" value={value} name={name} />
    </Box>
  );
}
